import React, {useEffect, useState } from 'react';
import s from './ImagesModal.module.scss'


interface ImageModalProps {
    images: any;
    visible: boolean;
    onClose: () => void;
    isViewerOpen: boolean
    setIsViewerOpen: (isViewerOpen: boolean) => void
    index: number
}

const ImagesModal: React.FC<ImageModalProps> = ({ images, visible, onClose, isViewerOpen, setIsViewerOpen, index }) => {
    const [currentIndex, setCurrentIndex] = useState(index);

    const closeViewer = () => {
        setIsViewerOpen(false);
        setCurrentIndex(0)
    };

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    };

    useEffect(() => {
        const handleKeyDown = (event: any) => {
            if (event.key === 'ArrowRight') handleNext();
            if (event.key === 'ArrowLeft') handlePrev();
            if (event.key === 'Escape') closeViewer();
        };

        if (isViewerOpen) {
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isViewerOpen]) // eslint-disable-line

    return (
        <div>
            {isViewerOpen && images?.length && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.9)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999
                    }}
                >
                    {images[currentIndex]?.format === 'mp4' || images[currentIndex]?.format === 'mov' || images[currentIndex]?.format === 'avi' || images[currentIndex]?.format === 'MOV' ? (
                        <video
                            controls
                            style={{ maxWidth: '90%', maxHeight: '90%' }}
                        >
                            <source src={`data:video/mp4;base64,${images[currentIndex]?.photo}`} type={`video/mp4`} />
                            Ihr Browser unterstützt das Video-Tag nicht.
                        </video>
                    ) : (
                        <img
                            src={`data:image/${images[currentIndex]?.format};base64,${images[currentIndex]?.photo}`}
                            alt="Fullscreen"
                            style={{ maxWidth: '90%', maxHeight: '90%', objectFit: 'contain' }}
                        />
                    )}
                    <>
                        <button
                            onClick={handlePrev}
                            style={{
                                left: '5%'
                            }}
                            className={currentIndex === 0 ? `${s.media_button} ${s.media_button__left}` : `${s.media_button}`}
                            disabled={currentIndex === 0}
                        >
                            ◀
                        </button>

                        <button
                            onClick={handleNext}
                            style={{
                                right: '5%'
                            }}
                            className={currentIndex === images.length - 1 ? `${s.media_button} ${s.media_button__right}` : `${s.media_button}`}
                            disabled={currentIndex === images.length - 1}
                        >
                            ▶
                        </button>
                    </>
                    <button
                        onClick={closeViewer}
                        style={{
                            position: 'absolute',
                            top: '20px',
                            right: '30px',
                            fontSize: '30px',
                            color: '#fff',
                            background: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                        }}
                    >
                        ✕
                    </button>
                </div>
            )}
        </div>
    );
};

export default ImagesModal;